export const BASE_URL =
  window?.__ENV__?.REACT_APP_BASE_URL ?? process?.env?.REACT_APP_BASE_URL;

export const REGION_UUID =
  window?.__ENV__?.REACT_APP_REGION_UUID ?? process?.env?.REACT_APP_REGION_UUID;

export const COOKIE_BOT_CBID =
  window?.__ENV__?.REACT_APP_COOKIE_BOT_CBID ??
  process?.env?.REACT_APP_COOKIE_BOT_CBID;
